// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"29e71fdd","384":"f9eb74c6","386":"0343d94d","736":"ac627772","942":"94005204"}[chunkId] + ".chunk.js";
};